import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllReportsData,
  getAllReportsDatas,
} from "../../../redux/service/action";
import DatesSelect from "./DatesSelect";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import upload from "../../assets/./images/upload.svg";
import VatReportExport from "./VatReportExport";

const VatReport = ({ selectedOptions, testingAccountFilter = "hide" }) => {
  const [params, setParams] = useState({
    type: "vat_report",
    start_date: "",
    end_date: "",
    user_id: selectedOptions,
    testing_account_filter: testingAccountFilter,
  });

  const dispatch = useDispatch();
  const vatReportData = useSelector(
    (state) => state?.reusableSlice?.getVatReportData
  );

  useEffect(() => {
    dispatch(getAllReportsDatas(params));
  }, [dispatch, params]);

  const formattedData =
    vatReportData?.vat_report?.map((item) => ({
      name: item?.month_name,
      vatInput: item?.vat_in,
      vatOutput: item?.vat_out,
    })) || [];

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      user_id: selectedOptions,
      testing_account_filter: testingAccountFilter,
    }));
  }, [selectedOptions, testingAccountFilter]);

  return (
    <div
      className="background-grpah"
      style={{
        width: "100%",
        padding: 20,
        background: "#F1F1F8",
        borderRadius: 10,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between w-100 pb-3"
        style={{ columnGap: "20px" }}
      >
        <div
          className="d-flex align-items-center "
          style={{ columnGap: "30px" }}
        >
          <h4 className="w-100">Vat Report</h4>
          <DatesSelect setParams={setParams} />
        </div>

        <VatReportExport params={params}></VatReportExport>
      </div>
      <div
        style={{
          width: "100%",
          padding: 20,
          background: "#F1F1F8",
          borderRadius: 10,
          height: "380px",
        }}
      >
        <ResponsiveContainer>
          <BarChart
            width={500}
            height={200}
            data={formattedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barSize={40}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="vatInput"
              fill="#A0E7A0"
              barSize={30}
              name="VAT Input"
              radius={[10, 10, 10, 10]}
            />
            <Bar
              dataKey="vatOutput"
              fill="#A88EF0"
              barSize={30}
              name="VAT Output"
              radius={[10, 10, 10, 10]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default VatReport;
